import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";

export const Logo = ({ small }) => (
  <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3 group">
    <span className={`grid place-items-center rounded-xl bg-[#d4f253] text-[#0f2a33] transition-transform duration-300 group-hover:-rotate-6 ${small ? "h-9 w-9" : "h-11 w-11"}`}>
      <ShoppingBag className={small ? "h-5 w-5" : "h-6 w-6"} strokeWidth={2.2} />
    </span>
    <span className="leading-tight">
      <span className="block font-display text-2xl font-extrabold tracking-tight text-white">ISoldIt</span>
      {!small && <span className="hidden sm:block text-[10px] font-bold tracking-[0.18em] text-[#d4f253] uppercase">Australia's Buy &amp; Sell Marketplace</span>}
    </span>
  </Link>
);
